import angular = require("angular");
import {SessionService} from "../services/session";
import {ChangePasswordController} from "../modals/changePassword";
import {EventType, CostType} from "../models/data";
import {LoginController} from "../modals/login";
import {LinkList} from "../directives/navigation/link";
import {Config} from "../config";
import _ = require("lodash");

export class LandingController {

  static $inject = ["$rootScope", "session", "$routeParams", "$uibModal", "$location", "$log"];

  session: SessionService;
  location;
  log;

  modal;
  currentModal;

  filter = {
    queryString: undefined,
    city: null,
    visibility: true,
    minDate: new Date(),
    eventType: EventType.ALL,
    costType: CostType.ALL,
    mealTypes: [],
    alcoholTypes: [],
    dietTypes: []
  };
  searchCallback;
  clearCallback;

  resetPasswordToken;
  currentCity;

  availableCities;
  filteredCities;

  eventsList = [];

  constructor($rootScope, session, $routeParams, $modal, $location, $log) {
    this.session = session;
    this.modal = $modal;
    this.location = $location;
    this.log = $log;
    this.availableCities = session.getAvailableCities();

    if ($routeParams.city) {
      this.currentCity = _.find(this.availableCities, {url: $routeParams.city});
      this.filterCities();
      this.filter.city = this.currentCity.code;
    }

    if (!this.currentCity) {
      this.currentCity = "";//this.availableCities[0];
      this.filter.city = "";
      this.filterCities();
    }

    if ($routeParams.q) {
      this.filter.queryString = $routeParams.q;
    }


    if ($routeParams.changePassword) {
      this.currentModal = ChangePasswordController.openUndismissableChangePasswordModal(this.modal, this, this.session, this.location);
      this.resetPasswordToken = $routeParams.changePassword;
    } else {

      if ($routeParams.signup) {
        if (!this.session.isLogged()) {
          this.currentModal = LoginController.openSignupModal(this.modal, this, $rootScope);
        }
        this.location.url('/landing');
      } else if ($routeParams.login) {
        if (!this.session.isLogged()) {
          this.currentModal = LoginController.openLoginModal(this.modal, this, $rootScope);
        }
        this.location.url('/landing');
      } else if ($routeParams.apply) {
        LinkList.becomeHostProcedure(session, this.modal, $rootScope);
      }

      if (this.session.isNotLogging()) {
        this.session.loadPublicEvents(this.filter);
      }

      if (this.session.isLogged()) {
        this.session.loadPrivateEvents(null,this.filter);
      }

      this.session.loadMyReservations();

      this.searchCallback = ()=> {this.search();};

      this.clearCallback = () => {
        this.log.debug("Clear callback");
        this.filter = {
          queryString: undefined,
          city: this.currentCity.code,
          visibility: true,
          minDate: new Date(),
          eventType: EventType.ALL,
          costType: CostType.ALL,
          mealTypes: [],
          alcoholTypes: [],
          dietTypes: []
        };
      };

    }
  }

  getCurrentEventList() {
    if (this.session.isLogged()) {
      return this.session.getData().privateEventList;
    }

    return this.session.getData().publicEventList;
  }


  getCurrentEventListLength() {
    if (this.session.isLogged()) {
      return this.session.getData().privateEventListMetadata && this.session.getData().privateEventListMetadata.total_count;
    }

    return this.session.getData().publicEventListMetadata && this.session.getData().publicEventListMetadata.total_count;
  }

  isCurrentEventListLoaded() {
    if (this.session.isLogged()) {
      return this.session.getData().hasLoadedPrivateEvents();
    }

    return this.session.getData().hasLoadedPublicEvents();
  }



  search() {
    this.log.debug(this.filter);
    /*
    if(this.filter.queryString.toLowerCase() == "new york"
      || this.filter.queryString.toLowerCase() == "nyc"
      || this.filter.queryString.toLowerCase() == "new york city"
      || this.filter.queryString.toLowerCase() == "brooklyn"
      || this.filter.queryString.toLowerCase() == "queens"
      || this.filter.queryString.toLowerCase() == "manhattan"
      || this.filter.queryString.toLowerCase() == "bronx"
      || this.filter.queryString.toLowerCase() == "staten island") {
        this.currentCityCode = "new_york";
        this.currentCityLabel = "new york"

        if(this.filter.queryString.toLowerCase() != "new york"
          && this.filter.queryString.toLowerCase() != "nyc"
          && this.filter.queryString.toLowerCase() != "new york city") {
          this.location.url('/landing/new_york?q=' + this.filter.queryString).replace().reload(false);
        } else {
            this.location.url('/landing/new_york').replace().reload(false);
        }
    } else if(this.filter.queryString.toLowerCase() == "chicago") {
        this.currentCityCode = "chicago";
        this.currentCityLabel = "chicago"
        this.location.url('/landing/chicago').replace().reload(false);
    } else if(this.filter.queryString.toLowerCase() == "san francisco"
              || this.filter.queryString.toLowerCase() == "bay_area") {
        this.currentCityCode = "bay_area";
        this.currentCityLabel = "bay area"
        this.location.url('/landing/bay_area').replace().reload(false);
    } else {
        this.currentCityCode = "others";
        this.currentCityLabel = "others"
        this.location.url('/landing/others?q=' + this.filter.queryString).replace().reload(false);
    }
    */

    if (this.session.isLogged()) {
      this.session.loadPrivateEvents(null,this.filter);
    } else {
      this.session.loadPublicEvents(this.filter);
    }
  }

  getCurrentCityCover() {
    return "/assets/Landing_Banner.jpg";
    //return this.currentCity.photo.original;
  }

  filterCities() {
    this.filteredCities = _.filter(this.availableCities, (city:any) => {
      return this.currentCity.code != city.code;
    });
  }

  getCurrentCityLabel() : string {
    if (this.currentCity) {
      return this.currentCity.label;
    } else {
      return "All States";
    }
  }
}



/** WEBPACK FOOTER **
 ** ./src/scripts/controllers/landing.ts
 **/